__turbopack_context__.v({
  "accordionContent": "FeaturedProductAccordion-module__rCbPdW__accordionContent",
  "accordionGroup": "FeaturedProductAccordion-module__rCbPdW__accordionGroup",
});
